const DEFAULT_TITLE = 'My Mortgage Canada | Mortgage Renewal Dashboard';
const DEFAULT_DESC = 'Master your mortgage renewal with data-driven insights, rate forecasts, and intelligent recommendations tailored for Canadian homeowners.';

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export const setPageSeo = ({ title, description, canonical, image, type = 'website', jsonLd }) => {
  document.title = title;
  setMeta('name', 'description', description);
  setMeta('property', 'og:title', title);
  setMeta('property', 'og:description', description);
  setMeta('property', 'og:type', type);
  setMeta('name', 'twitter:title', title);
  setMeta('name', 'twitter:description', description);
  if (canonical) {
    setCanonical(canonical);
    setMeta('property', 'og:url', canonical);
  }
  if (image) {
    setMeta('property', 'og:image', image);
    setMeta('name', 'twitter:image', image);
  }
  const existing = document.getElementById('page-jsonld');
  if (existing) existing.remove();
  if (jsonLd) {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'page-jsonld';
    script.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(script);
  }
};

export const resetPageSeo = () => {
  setPageSeo({
    title: DEFAULT_TITLE,
    description: DEFAULT_DESC,
    canonical: `${window.location.origin}/`,
  });
  const existing = document.getElementById('page-jsonld');
  if (existing) existing.remove();
};
